export default {
  auth: {
    register_title_button: "Kliknij, aby się zarejestrować",
    dont_have_account: "Nie masz konta?",
    sign_in_fb: "Zaloguj się przez Facebook",
    sign_in_google: "Zaloguj się przez Google",
    forgot_password_label: "Zapomniałeś hasła?",
    remember_me_label: "Zapamiętaj mnie",
    log_in_label: "Zaloguj się",
    password_label: "Hasło",
    enter_password_placeholder: "Wpisz hasło",
    enter_email_placeholder: "Wpisz e-mail",
    enter_login_or_email_label: "Wpisz login lub e-mail",
    error_wrong_login_or_password: "Podany login lub hasło jest nieprawidłowe",
    log_in_progress_label: "Logowanie...",
    server_error_try_again: "Błąd wewnętrzny serwera. Spróbuj ponownie później",
    email_is_required: "Pole adres e-mail jest wymagane",
    password_is_required: "Pole hasło jest wymagane",
    user_not_verified:
      "Konto nie zostało zweryfikowane. Na email podany przy rejestracji wysłany został link weryfikacyjny.",
    continue_with_facebook: "Zaloguj się przez Facebook",
    terms_of_service: "Warunki korzystania z serwisu",
  },
  register: {
    email: "Email",
    email_placeholder: "Wpisz Email",
    name: "Imię",
    name_placeholder: "Wpisz Imię",
    surname: "Nazwisko",
    surname_placeholder: "Wpisz Nazwisko",
    user_role: "Jestem",
    password: "Hasło",
    password_placeholder: "Wpisz Hasło",
    confirm_password: "Potwierdź hasło",
    confirm_password_placeholder: "Potwierdź hasło",
    regulations_acceptance_first: "Akceptuję warunki",
    regulations_acceptance_second: "regulaminu",
    personal_data_processing_agreement:
      "Wyrażam zgodę na przechowywanie moich danych osobowych",
    cancel: "Anuluj",
    create_account: "Utwórz konto",
    creating_account_in_progress: "Tworzenie konta...",
    error_while_creating_user:
      "Podczas tworzenia konta wystąpił błąd. Sprawdź dane i spróbuj ponownie.",
    success: "Konto zostało dodane!",
    verification_link_sent:
      "Na Twój adres e-mail został wysłany link weryfikacyjny. Kliknij w ten link, aby potwierdzić konto i móc się zalogować.",
    companyName: "Nazwa firmy",
    companyNIP: "Nip",
    phone: "Telefon",
    companyName_placeholder: "Wpisz nazwę firmy",
    companyNIP_placeholder: "Wpisz nip",
    phone_placeholder: "Wpisz telefon",
    thanks_for_register:
      "Dziękujemy za rejestracja konta w systemie EWOODS. W najbliższym czasie skontaktujemy się z Tobą żeby potwierdzić poprawność danych.",
    thanks: "Dziękujemy za rejestrację",
    login_page: "Wróc do strony logowania",
    validation: {
      string: "Pole musi zawierać ciąg znaków",
      required: "Pole jest wymagane",
      email: "Pole musi zawierać poprawny adres email",
      max: "Pole może zawierać maksymalnie {number} znaków",
      password:
        "Hasło powinno zawierać: min. 8 znaków, min. 1 duża litera, min. 1 mała litera, min.1 znak specjalny",
      passwordConfirmation: "Hasła muszą być takie same",
      regulationsAcceptance: "Musisz zaakceptować regulamin",
      dataProcessing: "Musisz wyrazić zgodę na przetwarzanie danych osobowych",
      userRole: "Wybrano niepoprawną role",
    },
  },
  forgot_password: {
    reset_password_title: "Zresetuj hasło",
    text:
      " Jeśli zapomniałeś/łaś hasła do swojego konta, podaj swój e-mail.\n" +
      "                Wyślemy Ci wiadomość, aby zresetować hasło.",
    enter_email_placeholder: "Wprowadź email",
    sending: "Wysyłanie...",
    send_button: "Wyślij",
    back_button: "Wstecz",
    success_text:
      "Wysłaliśmy instrukcje dotyczące zresetowania hasła na twój adres e-mail. Jeśli nie otrzymałeś wiadomości, sprawdź folder ze spamem i upewnij się, że ten adres e-mail jest zarejestrowany na stronie internetowej Ewoods.",
    resend_email_again: "Wyślij wiadomość ponownie",
    still_no_email: "Nadal nie masz wiadomości?",
    success_send_again: "Pomyślnie wysłano wiadomość ponownie",
    fail_send_again:
      "Wiadomość została wysłana. Jeżeli ponownie jej nie otrzymałeś, upewnij się, że jesteś zarejestrowany w systemie.",
  },
  reset_password: {
    title: "Zresetuj hasło",
    verification_code: "Kod weryfikacyjny",
    verification_code_placeholder: "Wpisz kod weryfikacyjny",
    password: "Nowe hasło",
    password_placeholder: "Wpisz nowe hasło",
    confirm_password: "Potwierdź hasło",
    confirm_password_placeholder: "Potwierdź nowe hasło",
    change_password: "Zmień hasło",
    changing_password_in_progress: "Zmiana hasła...",
    ready: "Gotowe!",
    password_changed: "Hasło zostało poprawnie zmienione.",
    click_to_go_to_login: "Kliknij, aby przejść do okna logowania",
    invalid_code:
      "Link do zmiany hasła wygasł. Wygeneruj nowy i spróbuj ponownie.",
  },
  profile: {
    my_profile_title: "Mój profil",
    close_edit_title: "Zamknij edycję",
    change_image_title: "Zmień zdjęcie",
    remove_image: "Usuń",
    specjalizations: "Specjalizacje",
    add_new_tag: "Dodaj nowy tag",
    enter_tag_placeholder: "Wpisz tag",
    my_profile_edit_title: "Edytuj profil",
    specialization_title: "Specjalizacje",
    description_title: "Opis",
    basic_company_data_title: "Dane podstawowe firmy",
    button_label: "Zaktualizuj informacje",
    updating: "Aktualizowanie",
    facebook_url_title: "Facebook URL",
    instagram_url_title: "Instagram URL",
    enter_link_placeholder: "Wpisz link do profilu",
    choose_label: "Wybierz",
    update_success: "Zaktualizowano profil",

    role: {
      client: "Klient",
      architect: "Architekt",
      admin: "Administrator",
    },
    company: {
      basic_data: "Dane podstawowe firmy",
      name: "Nazwa firmy",
      address: "Adres biura",
      city: "Miasto",
      zip_code: "Kod pocztowy",
      nip: "NIP",
      regon: "Regon",
      province: "Województwo",
      update_success: "Pomyślnie zaktualizowano dane",
      validation: {
        compnay: "Nazwa firmy musi być ciągiem znaków",
        address: "Adres musi byc ciągiem znaków",
        zip_code: "Niepoprawny kod pocztowy. Poprawny format to: xx-xxx",
        max_nip: "Nip musi składać się z 10 cyfr",
        regon_only_number: "Regon musi być ciągiem cyfr",
        max_regon: "Regon musi składać się z 9 cyft",
      },
    },
    personal_data: {
      basic_data: "Twoje dane podstawowe",
      firstname: "Imię",
      enter_firstname: "Wpisz imię",
      lastname: "Nazwisko",
      enter_lastname: "Wpisz nazwisko",
      email: "E-mail",
      enter_email: "Wpisz e-mail",
      phone: "Numer telefonu",
      enter_phone: "Wpisz numer telefonu",
      second_phone: "Numer telefonu 2",
      enter_second_phone: "Wpisz numer telefonu 2",
      update_info: "Zaktualizuj informacje",
      updating_info: "Aktualizowanie...",
    },
    validation: {
      wrong_url: "Niepoprawny adres url",
    },
  },
  profile_settings: {
    settings: "Ustawienia",
    password_change: "Zmiana hasła",
    password_change_success: "Pomyślnie zmieniono hasło",
    current_password: "Obecne hasło",
    current_password_placeholder: "Wpisz obecne hasło",
    new_password: "Nowe hasło",
    new_password_placeholder: "Wpisz nowe hasło",
    confirm_password: "Potwierdź hasło",
    confirm_password_placeholder: "Potwierdź hasło",
    update_information: "Zaktualizuj informacje",
    two_step_verification: "Weryfikacja dwuetapowa",
    two_step_verification_desc:
      "Dodatkowo zabezpiecz swoje konto dzięki drugiemu etapowi logowania.",
    two_step_verification_active: "Włączona",
    two_step_verification_inactive: "Wyłączona",
    select_verification_method: "Wybierz metodę weryfikacji",
    privacy_settings: "Ustawienia prywatności",
    receiving_notifications_about_forum_threads:
      "Nie chcę otrzymywać powiadomień o wątkach na forum",
    receiving_notifications_about_comments:
      "Nie chcę dostawać powiadomień o komentarzach do moich inspiracji",
    commenting_user_projects_by_others:
      "Nie zezwalam na komentowanie moich inspiracji przez innych użytkowników",
    receiving_notifications_of_ratings_by_others:
      "Nie chcę dostawać powiadomień o swojej ocenie przez innych użytkowników",
    receiving_messages_from_others_users:
      "Nie chcę otrzymywać wiadomości od innych użytkowników portalu (nie dotyczy administratora)",
    profile_indexing:
      "Nie zezwalam na indeksowanie mojego profilu, projektów, inspiracji przez wyszukiwarkę",
    delete_account: {
      delete_account_title: "Ustawienia konta",
      remove_account_button: "Usuń konto",
      confirm_delete: "Potwierdź usunięcie konta",
      delete: "Usuń konto",
      deleting: "Usuwam konto",
      cancel: "Anuluj",
      success: "Pomyślnie usunięto konto. Za chwilę zostaniesz wylogowany.",
    },
  },
  shopping_cart: {
    cart_is_empty: "Koszyk jest pusty",
    amount: "Ilość",
    price: "Cena",
    success_add_product: "Dodano produkty do koszyka",
    error_add_product: "Bład dodawania produktów do koszyka",
    success_remove_product: "Pomyślnie usunięto produkt",
    error_remove_product: "Błąd podczas usuwania produktu.",
    payment: "Zrealizuj zamówienie",
    during_payment: "Trwa realizacja...",
    delete_modal: {
      remove: "Usuń",
      removing: "Usuwanie",
      cancel: "Anuluj",
      title: "Usuń produkt",
      description: "Czy na pewno chcesz usunąć produkt o nazwie:",
    },
  },
  validate: {
    email: "Podany email jest nieprawidłowy",
    required: "Pole jest wymagane",
    number: "Pole musi być liczbą",
    password:
      "Hasło powinno zawierać: min. 8 znaków, min. 1 duża litera, min. 1 mała litera, min.1 znak specjalny",
    passwordConfirmation: "Hasła muszą być takie same",
    min_number: "Wartość musi być większa od {number}",
    max_number: "Wartość musi być mniejsza lub równa od {number}",
  },
  error_codes: {
    "000": "Użytkownik nie istnieje",
    "001": "Nieprawidłowe dane logowania",
    "002": "Podany email istnieje już w systemie",
    "003": "Błędny token",
    "004": "Błędne zapytanie", //Bad request
    "005": "Użytkownik jest już zarejestrowany za pomocą platformy google",
    "006": "Użytkownik jest już zarejestrowany za pomocą platformy facebook",
    "007": "Błędny kod weryfikacyjny",
    "008": "Nie znaleziono koszyka",
    "009": "Konto niezweryfikowane. E-mail z kodem został wysłany.",
    "010": "Produkt został już dodany do ulubionych",
    "011": "Obiekt już istnieje",
    "012": "Błędne hasło",
    "013": "Konto na Facebooku nie posiada adresu email",
    "014": "Na podany adres email zostało już wysłane zaproszenie",
    "018": "Działania na własnym adresie email są niedozwolone.",
    "022": "Wszystkie produkty są już dodane do koszyka",
    "023": "Żądana kwota jest zbyt wysoka",
    "024": "Status można zmienić wyłącznie dla oczekujących wypłat",
    "025": "Błędny kod weryfikacyjny",
    "027": "Nieprawidłowy format pliku",
    "028": "Użytkownik o tym adresem email już istnieje i jest architektem.",
    400: "Niepoprawny format pliku",
    401: "Brak autoryzacji",
    403: "Brak uprawnień do wykonania tej akcji",
    404: "Nie znaleziono obiektu",
    default: "Podczas przetwarzania żądania wystąpił błąd.",
  },
  verification: {
    title: "Weryfikacja konta",
    in_progress: "Prosimy o cierpliwość, trwa weryfikacja...",
    success: "Konto zostało zweryfikowane. Możesz się zalogować.",
    error_during_verification:
      "Podczas weryfikacji wystąpił błąd. Upewnij się, że link jest poprawny.",
  },
  accept_project_invitation: {
    title: "Akceptowanie zaproszenia do projektu",
    in_progress: "Prosimy o cierpliwość, trwa akceptowanie...",
    success:
      "Zaproszenie zostało zaakceptowane. Zaloguj się do systemu, aby poznać szczegóły.",
    error_during_verification:
      "Podczas akceptowania zaproszenia wystąpił błąd. Upewnij się, że link jest poprawny.",
  },
  page_not_found: {
    desc: "Niestety nie znaleziono strony, której szukasz. Sprawdź czy wprowadziłeś poprawny adres.",
    back: "Wróć do strony głównej",
  },
  alert: {
    successfully_saved_data: "Pomyślnie zapisano dane",
    successfully_updated_data: "Pomyślnie zaktualizowano dane",
    successfully_deleted_data: "Pomyślnie usunięto dane",
    error_during_saving_data: "Błąd zapisu danych",
    error_during_updating_data: "Błąd aktualizacji danych",
    error_during_deleting_data: "Błąd usuwania danych",
  },
  menu: {
    my_profile: "Mój profil",
    my_projects: "Moje projekty",
    my_inspirations: "Moje inspiracje",
    my_clients: "Moi klienci",
    favourites: "Ulubione",
    my_finances: "Moje Finanse",
    statistics: "Statystyka",
    notifications: "Powiadomienia",
    settings: "Ustawienia",
    logout: "Wyloguj się",

    admin: {
      products: "Produkty",
      all_products: "Wszystkie produkty",
      shop_products: "Produkty na sklepie",
      users: "Użytkownicy",
      users_ewoods: "Ewoods",
      users_architect: "Architekci",
      users_client: "Klienci",
      style_quiz: "Zarządzanie stylami",
      producers: "Producenci",
      orders: "Zamówienia",
      finance: "Finanse",
      style_quiz_steps: "Etapy style quiz",
    },
  },
  admin: {
    general: {
      back: "Wstecz",
      button_update_data_title: "Zaktualizuj informacje",
      your_profile: "Twój profil",
      logout: "Wyloguj",
      settings: "Ustawienia",
    },
    all_products: {
      all_products: "Wszystkie produkty",
      add: "Dodaj produkt",
      import: "Importuj",
      export: "Eksportuj",
      page_of: "z",
      search: "Szukaj",
      sort: "Sortuj",
      filter: "Filtruj",
      filter_type: "Typ Produktu",
      filter_status: "Status",
      filter_vendor: "Producent",
      show_on_page: "Pokaż na stronie",
      selected: "Wybrano",
      edit: "Edytuj",
      more: "Więcej",
      share: "Udostępnij produkt na sklepie",
      delete_from_shop: "Usuń produkt ze sklepu",
      delete_from_system: "Usuń produkt z systemu",
      add_tags: "Dodaj tagi",
      delete_tags: "Usuń tagi",
      product_id: "ID Produktu",
      added_date: "Data dodania",
      producer: "Producent",
      price: "Cena",
      stock: "Stan magazynowy",
      furniture_type: "Typ mebla",
      status: "Status",
      shopify_url: "Link shopify",
      no_products_in_integrator: "Nie masz produktów w integratorze",
      manage_your_products: "Nie masz produktów w integratorze",
      loading: "Ładowanie...",
      sort_list: {
        "createdAt-DESC": "Data dodania - malejąco",
        createdAt_ASC: "Data dodania - rosnąco",
        "id-DESC": "ID - malejąco",
        "id-ASC": "ID - rosnąco",
        "vendor-DESC": "Producent - malejąco",
        "vendor-ASC": "Producent - rosnąco",
        "product_type-DESC": "Typ - malejąco",
        "product_type-ASC": "Typ - rosnąco",
      },
      all_product_types: "Wszystko",
      all_statuses: "Wszystkie",
      all_vendors: "Wszyscy",
    },
    product: {
      detail: {
        title: "Podgląd produktu",
        back_to_all_products: "Wszystkie produkty",
        add_new_images: "Dodaj nowe zdjęcia",
        no_images: "Brak zdjęć",
        success_upload: "Pomyslnie dodano nowe zdjęcia",
        price: "Cena",
        category: "Kategoria",
        tags: "Tagi",
      },
      image: {
        delete_title: "Usuń zdjęcie produktu",
        confirmation_delete: "Czy potwierdzasz usunięcie zdjęcia?",
        cancel_delete: "Anuluj",
        confirm_delete: "Usuń",
        deleting: "Usuwanie...",
        success_remove: "Pomyślnie usunięto zdjęcie",
      },
    },
    orders: {
      title: "Zamówienia",
      arrow_left_alt: "Strzałka w lewo",
      arrow_right_alt: "Strzałka w prawo",
      search_alt: "Ikona lupki",
      search: "Szukaj",
      project_name: "Nazwa projektu",
      order_number: "Nr zamówienia",
      realization_time: "Przewidywany termin realizacji",
      estimated_architect_commission: "Szacowana prowizja architekta",
      total_value: "Łączna wartość",
      status: "Status",
      architect: "Architekt",
      loading: "Ładowanie...",
      no_orders: "Brak zamówień",
      edit_order_modal: {
        order: "Zamówienie",
        expected_completion_date: "Data realizacji",
        expected_completion_date_placeholder: "Data realizacji",
        architect_commission: "Prowizja architekta",
        architect_commission_placeholder: "Podaj prowizję",
        date_label_aria: "Wybierz datę",
        ok_label: "Zatwierdź",
        cancel_label: "Anuluj",
        updating_success: "Pomyślnie zaktualizowano zamówienie",
      },
    },
    profile: {
      my_profile_title: "Mój profil",
      my_profile_settings_title: "Ustawienia",
      personal_image: "Zdjęcie główne",
      update_success: "Pomyślnie zaktualizowano dane",
      img_update_success: "Pomyślnie zaktualizowano zdjęcie",
      img_delete_success: "Pomyślnie usunięto zdjęcie",
      address_title: "Adres",
      name: "Imię",
      enter_name: "Wpisz imię",
      surname: "Nazwisko",
      enter_surname: "Wpisz nazwisko",
      email: "E-mail",
      enter_email: "Wpisz e-mail",
      phone_number: `Numer Telefonu`,
      enter_phone_number: `Wpisz numer Telefonu`,
      street: "Ulica",
      enter_street: "Wpisz ulica",
      premises_number: "Numer lokalu",
      enter_premises_number: "Wpisz numer lokalu",
      apartment_number: "Numer mieszkania",
      enter_apartment_number: "Wpisz numer mieszkania",
      zip_code: "Kod pocztowy",
      enter_zip_code: "Wpisz kod pocztowy",
      city: "Miasto",
      enter_city: "Wpisz miasto",
      validation: {
        zip_code: "Niepoprawny kod pocztowy. Poprawny format to: xx-xxx",
      },
      update_data_success: "Pomyślnie zaktualizowano dane profilowe",
      update_profile_img: {
        alert_success: "Pomyślnie zaktualizowano zdjęcie profilowe",
      },
      delete_profile_img: {
        alert_success: "Pomyślnie usunięto zdjęcie profilowe",
      },
      settings: {
        back: "Wstecz",
        my_profile: "Mój profil",
        settings: "Ustawienia",
        manage_account: "Zarządzaj swoim kontem",
        change_password: "Zmień hasło",
        close_dialog: "Zamknij",
        changing_password: "Zmiana hasła",
        old_password: "Stare hasło",
        old_password_placeholder: "Wpisz stare hasło",
        new_password: "Nowe hasło",
        new_password_placeholder: "Wpisz nowe hasło",
        confirm_password: "Potwierdź nowe hasło",
        cancel: "Anuluj",
        save: "Zapisz",
        yes: "Tak",
        no: "Nie",
        saving_changes_confirmation: "Czy na pewno chcesz zapisać zmiany?",
        update_data_success: "Pomyślnie zaktualizowano dane",
      },
    },
    users: {
      ewoods: {
        title: "Ewoods",
        add_user: "Dodaj użytkownika",
        firstname: "Imię",
        surname: "Nazwisko",
        function: "Funkcja",
        email: "Email",
        phone: "Telefon",
        change_user_data: "Zmień dane i uprawnienia użytkownika",
        access_blocked:
          "Dostęp dla tego użytkownika jest zablokowany, kliknij aby odblokować dostęp",
        access_allowed:
          "Dostęp dla tego użytkownika jest odblokowany, kliknij aby zablokować dostęp",
        delete_user: "Usuń użytkownika",
        loading: "Ładowanie...",
        add_user_modal: {
          dialog_close: "Zamknij",
          edit_data: "Edytuj dane użytkownika",
          firstname: "Imię",
          firstname_placeholder: "Wpisz imię",
          email: "Email",
          email_placeholder: "Wpisz email",
          surname: "Nazwisko",
          surname_placeholder: "Wpisz nazwisko",
          phone: "Telefon",
          phone_placeholder: "Wpisz telefon",
          cancel: "Anuluj",
          save: "Zapisz",
          saving: "Zapisywanie...",
          company_name: "Nazwa firmy",
          company_address: "Adres firmy",
          company_city: "Miasto firmy",
          company_zip_code: "Kod pocztowy firmy",
          company_nip: "NIP firmy",
          company_regon: "REGON firmy",
          company_province: "Województwo firmy",
          description: "Opis",
          phone_second: "Drugi numer telefonu",
          street: "Ulica",
          street_number: "Numer",
          flat_number: "Numer mieszkania",
          city: "Miasto",
          postcode: "Kod pocztowy",

          company_name_placeholder: "Wpisz nazwę firmy",
          company_address_placeholder: "Wpisz adres firmy",
          company_city_placeholder: "Wpisz miasto firmy",
          company_zip_code_placeholder: "Wpisz kod pocztowy firmy",
          company_nip_placeholder: "Wpisz NIP firmy",
          company_regon_placeholder: "Wpisz REGON firmy",
          company_province_placeholder: "Wpisz województwo firmy",
          description_placeholder: "Opis",
          phone_second_placeholder: "Wpisz drugi numer telefonu",
          street_placeholder: "Wpisz ulicę",
          street_number_placeholder: "Wpisz Numer",
          flat_number_placeholder: "Wpisz numer mieszkania",
          city_placeholder: "Wpisz miasto",
          postcode_placeholder: "Wpisz kod pocztowy",
        },
        deleting_user_confirmation: "Czy na pewno chcesz usunąć użytkownika?",
      },
    },
    style_quiz: {
      title: "Konfiguracja style quiz",
      style: "Styl",
      percent: "Procent",
      description: "Opis",
      change_style: "Zmień zdjęcie",
      change_description: "Edytuj opis stylu",
      details: "rozwiń/zwiń",
      add_description: "Dodaj opis stylu",
      delete: "Usuń opis",
      edit_desc_modal: {
        dialog_close: "Zamknij",
        edit_data: "Opis stylu",
        percent: "Procent",
        percent_placeholder: "Podaj procent",
        description: "Opis",
        description_placeholder: "Podaj opis",
        deleted: "Pomyślnie usunięto opis",
      },
      edit_style_modal: {
        dialog_close: "Zamknij",
        style: "Styl",
        new_img: "Nowe zdjęcie",
      },
      delete_desc_modal: {
        cancel: "Anuluj",
        delete: "Usuń",
        deleting: "Usuwanie",
        dialog_close: "Zamknij",
        deleting_desc: "Usuwanie opisu",
        deleting_confirmation: "Czy na pewno chcesz usunąć opis",
      },
    },
    style_quiz_steps: {
      step: "Etap",
      add_photo: "Dodaj zdjęcie",
      add_photo_error: "Maksymalna ilość zdjęć to: {0}",
      step_name: "Nazwa przypisana do zdjęcia",
      tag_name: "Tag odpowiadający zdjęciu",
      tag2_name: "Drugi tag odpowiadający zdjęciu",
      save_changes: "Zapisz zmiany",
      edit_image: "Edytuj zdjęcie",
      delete_image: "Usuń",
      wrong_file_format: "Dostępne formaty plików to: .jpg, .jpeg i .png",
      file_error: "Wystąpił błąd w trakcie ładowania zdjęcia",
      photo_added: "Zdjęcie zostało dodane poprawnie",
      add_photo_title: "Dodaj nowe zdjęcie do etapu",
      name_placeholder: "Nazwa",
      tag_placeholder: "Nazwa tagu",
      delete_question: "Czy na pewno chcesz usunąć dane?",
      style_to_img: "Styl odpowiadający zdjęciu",
      empty_data: "Wszystkie pola zdjęcia muszą być wypełnione",
      errors: {
        "026": "Styl jest polem wymaganym",
        default: "Wystąpił błąd w trakcie wykonywania akcji",
        422: "Wystąpił problem z załączonym zdjęciem",
      },
    },
    producers: {
      title: "Producenci",
      name: "Nazwa",
      slug: "Slug",
      region: "Region",
      loading: "Ładowanie...",
      edit: "Edytuj",
      edit_icon: "Ikona edycji",
      import_icon: "Ikona importu",
      import: "Imporuj",
      delete: "Usuń",
      delete_icon: "Ikona kosza na śmieci",
      delete_producer_modal: {
        dialog_close: "Zamknij",
        deleting_producer: "Usuwanie producenta",
        deleting_producer_confirmation: "Czy na pewno chcesz usunąć producenta",
        cancel: "Anuluj",
        delete: "Usuń",
        deleting: "Usuwanie...",
        deleting_success: "Pomyślnie usunięto producenta",
      },
      add_producer: "Dodaj producenta",
      add_icon: "Ikona plusa",
      add_producer_modal: {
        dialog_close: "Zamknij",
        producer: "Producent",
        name: "Nazwa",
        name_placeholder: "Podaj nazwę",
        slug: "Slug",
        slug_placeholder: "Podaj slug",
        cancel: "Anuluj",
        save: "Zapisz",
        saving: "Zapisywanie...",
        adding_success: "Pomyślnie dodano producenta",
        updating_success: "Pomyślnie zaktualizowano producenta",
      },
      import_file_modal: {
        dialog_close: "Zamknij",
        title: "Import",
        file: "Plik",
        type: "Rodzaj importu",
        choose_type: "Wybierz",
        cancel: "Anuluj",
        import: "Importuj",
        importing: "Importowanie...",
        importing_success: "Pomyślnie zaimportowano plik",
        exchange_rate: "Kurs GBP",
        price_multiplier: "Mnożnik ceny",
        exchange_rate_placeholder: "Podaj kurs",
        price_multiplier_placeholder: "Podaj mnożnik ceny",
        file_types: {
          PRODUCTS: "Produkty",
          PRODUCTS_PRICES: "Ceny",
          VENDORS_DETAILS: "Szczegóły producentów",
        },
      },
    },
    finance: {
      id: "ID",
      email: "Email",
      status: "Status",
      amount: "Kwota",
      status_all: "Wszystkie",
      status_waiting: "Dyspozycja w trakcie realizacji",
      status_accepted: "Zapłacono",
      status_rejected: "Anulowano",
      no_finance: "Brak finansów",
      actions: "Akcje",
      success_change_status: "Pomyślnie zmioniono status",
      fail_change_status: "Błąd podczas zmiany statusu",
      personal_data: "Dane osobowe",
      company: "Dane firmowe",
      account_number: "Numer konta bankowego",
    },
  },
  finances: {
    bank_account: {
      update: "Zaktualizuj informacje",
      updating: "Aktualizowanie...",
      title: "Moje konto bankowe",
      account_number: "Numer konta bankowego",
      account_number_placeholder: "Wpisz numer konta bankowego",
      code_was_sent: "Na Twój adres email został wysłany kod weryfikacyjny",
      code: "Kod weryfikacyjny",
      code_placeholder: "Wpisz kod weryfikacyjny",
      no_account_number: "Brak numeru",
      edit: "Edytuj",
      cancel: "Anuluj",
      update_success: "Pomyślnie zaktualizowano dane",
    },
    wallet: {
      my_wallet: "Mój portfel",
      available_funds: "Dostępne środki",
      withdraw_now: "Wypłać teraz",
      waiting_for_payment: "Oczekiwanie na płatność",
      payout_modal: {
        dialog_close: "Zamknij",
        title: "Wypłata",
        type_amount: "Wpisz kwotę wypłaty",
        payout: "Wypłać",
        making_payout: "Wypłać...",
        no_account_number: "Brak numeru",
        payout_success: "Pomyślnie wysłano wniosek o wypłatę",
      },
    },
    transactions_history: {
      title: "Historia transakcji",
      no_transactions: "Brak transakcji",
      date_and_time: "Data i czas",
      transaction_type: "Typ transakcji",
      amount: "Kwota",
      status: "Status",
      transaction_id: "ID Transakcji",
      filter: "Filtruj",
      order: "Sortuj",
      order_list: {
        createdAt_DESC: "Data dodania - malejąco",
        createdAt_ASC: "Data dodania - rosnąco",
        amount_DESC: "Kwota - malejąco",
        amount_ASC: "Kwota - rosnąco",
      },
      filter_list: {
        status_REJECTED: "Odrzucone",
        status_WAITING: "W trakcie",
        status_ACCEPTED: "Zakończone",
      },
      statuses: {
        WAITING: "W trakcie",
        ACCEPTED: "Zakończona",
        REJECTED: "Odrzucona",
      },
      types: {
        PAYOUT: "Wypłata",
      },
    },
  },
  clients: {
    my_clients: "Moi klienci",
    sort: "Sortuj",
    filter: "Filtruj",
    delete: "Usuń",
    more: "Więcej",
    ready: "gotowe",
    info_add_new_client:
      'Dodawanie nowego klienta odbywa się poprzez utworzenie projektu w zakładce "Moje projekty" ',
    sort_list: {
      firstName_DESC: "Imię - malejąco",
      firstName_ASC: "Imię - rosnąco",
      lastName_DESC: "Nazwisko - malejąco",
      lastName_ASC: "Nazwisko - rosnąco",
      email_DESC: "Email - malejąco",
      email_ASC: "Email - rosnąco",
      createdAt_DESC: "Data dodania - malejąco",
      createdAt_ASC: "Data dodania - rosnąco",
    },
    filter_list: {
      ACTIVE_PROJECT: "Aktywny projekt",
      FINISHED_PROJECT: "Nieaktywny projekt",
    },
  },
  projects: {
    add: {
      dialog_close: "Zamknij",
      img_notebooks: "Obrazek przedstawiajacy dwa notesy",
      start: "Zaczynamy",
      add_investor: "Dodaj nowego inwestora",
      add_investor_by_email: "Dodaj inwestora za pomocą adresu e-mail",
      search_investors_title: "Dodaj inwestora z listy",
      search_investors_placeholder: "Szukaj inwestorów",
      search_investors_empty_result: "Brak inwestorów na liście",
      name: "Imię",
      name_placeholder: "Wpisz imię inwestora",
      lastname: "Nazwisko",
      lastname_placeholder: "Wpisz nazwisko inwestora",
      phone: "Telefon",
      phone_placeholder: "Wpisz telefon inwestora",
      email: "Email",
      email_placeholder: "Wpisz email inwestora",
      project_name: "Nazwa projektu",
      project_name_placeholder: "Wpisz nazwę projektu",
      create_project: "Stwórz nowy projekt",
      add_investor_to_the_project: "Dodaj inwestora do projektu",
    },
    sort_list: {
      createdAt_DESC: "Data dodania - malejąco",
      createdAt_ASC: "Data dodania - rosnąco",
      updatedAt_DESC: "Data edycji - malejąco",
      updatedAt_ASC: "Data edycji - rosnąco",
      progress_DESC: "Progres - malejąco",
      progress_ASC: "Progres - rosnąco",
      name_DESC: "Nazwa - malejąco",
      name_ASC: "Nazwa - rosnąco",
      deadline_DESC: "Deadline - malejąco",
      deadline_ASC: "Deadline - rosnąco",
    },
    filter_list: {
      status_ACTIVE: "Aktywny projekt",
      status_FINISHED: "Nieaktywny projekt",
    },
    status: {
      active: "Aktywny",
      finished: "Zakończony",
    },
    list: {
      my_projects: "Moje projekty",
      add_project: "Dodaj projekt",
      sort: "Sortuj",
      filter: "Filtruj",
      edit: "Edytuj",
      settings: "Ustawienia",
      delete: "Usuń",
      deadline: "Deadline",
      end_project: "Zakończenie projektu",
      change_image: "Zmień zdjęcie",
    },
  },
  project_settings: {
    title: "Ustawienia projektu",
    complete_later: "Uzupełnij później",
    rooms: "Pomieszczenia",
    add_room: "Dodaj pomieszczenie",
    furnitures: "Meble",
    parameters: "Parametry",
    delete: "Usuń",
    icon_plus: "Dodaj",
    dialog_close: "Zamknij",
    dialog_delete: "Usuń",

    add_room_modal: {
      add_room: "Dodaj pomieszczenie",
      type: "Rodzaj",
      select_room_placeholder: "Wybierz pomieszczenie",
      no_rooms: "Brak pomieszczeń",
      amount: "Ilość",
      add: "Dodaj",
      adding: "Dodawanie...",
      alert_success: "Pomyślnie dodano pomieszczenie",
      alert_fail: "Błąd podczas dodawania pomieszczenia",
    },
    add_furniture_modal: {
      add_furnitures: "Dodaj meble",
      dialog_close: "Zamknij",
      more: "Więcej",
      add: "Dodaj",
      adding: "Dodawanie...",
      alert_success: "Pomyślnie dodano meble",
    },
    room_parameters_modal: {
      furniture_params: "Parametry produktów",
      dialog_close: "Zamknij",
      from: "od",
      to: "do",
      save: "Zapisz",
      saving: "Zapisywanie...",
      alert_success: "Pomyślnie zapisano parametry",
    },
    delete_room_modal: {
      deleting_room: "Usuwanie pomieszczenia",
      are_you_sure: "Czy na pewno chcesz usunąć pomieszczenie",
      cancel: "Anuluj",
      delete: "Usuń",
      deleting: "Usuwanie...",
      dialog_close: "Zamknij",
      alert_success: "Pomyślnie usunięto pomieszczenie",
      alert_fail: "Błąd podczas usuwania",
    },
    delete_furniture_modal: {
      deleting_furniture: "Usuwanie mebla",
      are_you_sure: "Czy na pewno chcesz usunąć mebel",
      cancel: "Anuluj",
      delete: "Usuń",
      deleting: "Usuwanie...",
      alert_success: "Pomyślnie usunięto mebel",
      alert_fail: "Błąd podczas usuwania",
    },

    lead: {
      date_label_aria: "Wybierz datę",
      ok_label: "Zatwierdź",
      cancel_label: "Anuluj",
      lead_time: "Termin realizacji projektu",
      project_start: "Rozpoczęcie projektu",
      project_deadline: "Deadline projektu",
      lead_time_img: "Zdjęcie czasu realizacji",
      save: "Zapisz",
      save_success_title: "Pomyślnie zaktualizowano dane",
      save_success_desc: "Dane o terminie realizacji zostały zaktualizowane",
      save_fail_title: "Błąd aktualizacji danych",
      save_fail_desc: "Dane o terminie realizacji nie zostały zaktualizowane",
    },
    budget: {
      title: "Budżet",
      remains: "Pozostało",
      shopping: "Zakupy",
      currency: "zł",
      button_save: "Zapisz",
      save_success_title: "Pomyślnie zaktualizowano dane",
      save_success_desc: "Dane o budżecie zostały zaktualizowane",
      save_fail_title: "Błąd aktualizacji danych",
      save_fail_desc: "Dane o budżecie nie zostały zaktualizowane",
    },
    team: {
      title: "Zespół",
      add_person: "Dodaj osobę",
      user_from: "Użytkownik od",
      phone: "Telefon kontaktowy",
      add_person_to_project_title: "Dodaj osobę do projektu",
      user_type: "Rodzaj użytkownika",
      team_member: "Członek zespołu",
      client: "Klient",
      position: "Stanowisko",
      select_position: "Wybierz stanowisko",
      firstname: "Imię",
      enter_firstname: "Wpisz imię",
      lastname: "Naziwsko",
      enter_lastname: "Wpisz nazwisko",
      phone_number: "Telefon",
      enter_phone_number: "Wpisz numer telefonu",
      email: "Adres email",
      enter_email: "Wpisz adres email",
      add_button: "Dodaj",
      save_success_title: "Pomyślnie zaktualizowano dane",
      save_success_desc: "Dane o zespole zostały zaktualizowane",
      save_fail_title: "Błąd aktualizacji danych",
      save_fail_desc: "Dane o zespole nie zostały zaktualizowane",
      remove_fail_title: "Błąd usuwania członka zespołu",
      remove_success_title: "Pomyślnie usunięto członka zespołu",
      modal: {
        remove_member_title: "Usuń członka zespołu",
        do_you_want_remove_members:
          "Czy na pewno chcesz usunąć członka zespołu",
        cancel: "Anuluj",
        remove: "Usuń",
        removing: "Usuwanie...",
      },
    },
    client_profile: {
      title: "Profil klienta",
      save: "Zapisz",
      saving: "Zapisywanie..",
      alert_success: "Pomyślnie zapisano profil klienta",
    },
  },
  delete_client_modal: {
    dialog_close: "Zamknij",
    deleting_client: "Usuwanie Klienta",
    deleting_client_confirmation: "Czy na pewno chcesz usunąć klienta",
    cancel: "Anuluj",
    delete: "Usuń",
    deleting: "Usuwanie...",
    deleting_success: "Pomyślnie usunięto klienta",
  },
  delete_project_modal: {
    dialog_close: "Zamknij",
    deleting_project: "Usuwanie projektu",
    deleting_project_confirmation: "Czy na pewno chcesz usunąć project",
    cancel: "Anuluj",
    delete: "Usuń",
    deleting: "Usuwanie...",
    deleting_success: "Pomyślnie usunięto projekt",
  },
  style_quiz: {
    go_back: "Wróć do panelu",
    photos: {
      select_photos: "Wybierz 10 zdjęć, które najbardziej Ci się podobają",
      next: "Dalej",
      saving: "Zapisywanie...",
      max_10: "Możesz wybrać maksymalnie 10 zdjęć",
      select_10: "Wybierz 10 zdjęć",
    },
    result: {
      your_style: "Twój styl to",
      style: "Styl",
      see_products: "Zobacz produkty dopasowane do Twojego stylu",
      make_project: "Stwórz kompletny projekt",
      making_project: "Tworzenie projektu...",
      price: "Cena",
    },
    more: {
      more_info:
        "Potrzebujemy trochę więcej informacji od Ciebie, żeby dopasować ofertę",
      img_alt: "Grafika przedstawiająca kobietę z dokumentami",
      next: "Dalej",
    },
    profile: {
      select_profile: "Wybierz profil klienta",
      retail: "Detaliczny",
      retail_img: "Ikona klienta detalicznego",
      retail_desc: "Urządzam własne mieszkanie, dom, biuro",
      business: "Biznesowy",
      business_img: "Ikona klienta biznesowego",
      business_desc: "Urządzam przestrzeń firmową, biuro, potrzebuje faktury",
      prev: "Wróć",
      next: "Dalej",
      skip: "Pomiń",
    },
    rooms: {
      select_room: "Wybierz pomieszczenie, które chcesz urządzić",
      select_room_desc: "Możesz wybrać dowolną liczbę",
      prev: "Wróć",
      next: "Dalej",
    },
    furnitures: {
      select_furnitures: "Wybierz meble, które chcesz kupić",
      select_furnitures_desc: "Możesz wybrać dowolną liczbę",
      prev: "Wróć",
      next: "Dalej",
    },
    deadline: {
      select_deadline: "Wybierz termin realizacji zamówienia",
      select_deadline_desc:
        "Postaramy się dobrać i pokazać produkty dostępne w tym terminie",
      prev: "Wróć",
      next: "Dalej",
      TWO_FOUR_WEEKS: "2-4 tygodni",
      FOUR_EIGHT_WEEKS: "4-8 tygodni",
      EIGHT_TWELVE_WEEKS: "8-12 tygodni",
    },
    budget: {
      title: "Czy wiesz, jaki budżet masz na projekt?",
      desc: "Postaramy się dobrać dla Ciebie produkty dostępne w tym sektorze",
      yes: "Tak",
      no: "Nie",
      enter_amount: "Wpisz kwotę",
      enter_amount_placeholder: "Wpisz kwotę...",
      prev: "Wróć",
      next: "Dalej",
    },
    steps: {
      profile: "Profil",
      rooms: "Pomieszczenie",
      furnitures: "Meble",
      deadline: "Termin",
      budget: "Budżet",
    },
  },
  project_details: {
    settings_title: "Ustawienia",

    breadcrumbs: {
      project: "Projekty",
    },
    tab_menu: {
      style_quiz: "Style Quiz",
      ewoods_proposal: "Propozycje Ewoods",
      shopping_list: "Listy zakupowe",
      orders: "Zamówienia",
      favorites: "Ulubione",
      visualization: "Wizualizacje",
      "2d_planner": "Planer 2D",
    },
    proposal: {
      add_to_shopping_cart: "Dodaj do koszyka",
      instalments: "Raty",
      price: "Cena",
      quantity: "Ilość",
      parameters: "PARAMETRY",
      slider_arrow_left_alt: "Strzałka zmiany slidera (lewa)",
      slider_arrow_right_alt: "Strzałka zmiany slidera (prawa)",
      share: "Udostępnij",
      print: "Wydrukuj",
      send: "Wyślij",
      add_to_inspiration: "Dodaj do inspiracji",
      success_exchange_product: "Pomyślnie wymieniono produkt",
      success_add_product: "Pomyślnie dodano produkt",
      parameters_modal: {
        furniture_params: "Parametry produktów",
        rooms: "Pomieszczenie",
        dialog_close: "Zamknij",
        from: "od",
        to: "do",
        save: "Zapisz",
        saving: "Zapisywanie...",
        alert_success: "Pomyślnie zapisano parametry",
      },
      comments: {
        enter_message: "Napisz komentarz...",
        enter_answer: "Napisz odpowiedź...",
        add_button: "Dodaj",
        cancel_button: "Anuluj",
        answer_button: "Odpowiedz",
        day_ago: " dni temu.",
        hour_ago: " godzin temu.",
        minutes_ago: " minut temu.",
        success_remove: "Pomyślnie usunięto komentarz",
        fail_remove: "Wystąpił błąd podczas usuwania komentarza",
        success_edit: "Pomyślnie edytowano komentarz",
        fail_edit: "Wystąpił błąd podczas edytowania komentarza",
        success_add: "Pomyślnie dodano komentarz",
        error_add: "Błąd podczas dodawanai komentarza",
        error_fetch_comments: "Błąd podczas pobierania komentarzy",
        delete_modal: {
          title: "Usuń komentarz",
          description: "Czy na pewno chcesz usunąć komentarz?",
          cancel: "Anuluj",
          delete: "Zatwierdź",
          deleting: "Usuwanie...",
        },
      },
      exchange: {
        title: "Wymień",
        kind_of_materials: "Rodzaj tkaniny",
        filters: "Filtrowanie",
        filter: "Filtruj",
        architect_proposal: "Propozycje architekta",
        choose: "Wybierz",
        sorts: "Sortuj",
      },
      empty_proposals: "Brak propozycji.",
    },
    style_quiz: {
      copy_link: "Skopiuj link",
      success_send_email_desc: "Pomyślnie wysłano zaproszenia do klienta",
      success_send_email_title: "Pomyślnie wysłano zaproszenie",
      do_again: "Przejdź jeszcze raz",
      dont_have_result_yet: "Nie ma jeszcze wyników...",
      do_you_know_which_style: "Czy wiesz, jaki chcesz styl?",
      choose_your_style: "Wybierz swój styl lub przejdź quiz i dopasuj wynik",
      know_my_style: "Znam swój styl - sam wybiorę",
      want_to_style_quiz: "Chcę przejść przez Style Quiz",
      invite_client_to: "Zaproś klienta do zrobienia Style Quiz",
      copy_direct_link: "Przekopiuj bezpośredni link",
      copied: "Skopiowano",
      or: "albo",
      send_direct_link: "Wyślij bezpośrednio na e-mail klienta",
      send_invitation: "Wyślij zaproszenie",
      investor_quiz_group: "Style grupy inwestorów",
      do_it_again: "Przejdź jeszcze raz",
      select_your_style: "Wybierz swój styl",
      select_your_style_from: "Wybierz styl z {number} propozycji",
      back: "Wstecz",
      next: "Dalej",
      which_style_do_you_prefer: "Jaki styl preferujesz?",
      select_room_type: "Wybierz rodzaj pomieszczenia",
      select_ornaments_you_like: "Wybierz zdobienia, które Ci się podobają",
      select_ornaments: "Wybierz zdobienia dekoracyjne",
      select_room_you_like: "Wybierz pomieszczenie, które Ci się podoba",
      select_decors: "Wybierz aranżacje dopasowane dla Ciebie",
    },
    orders: {
      table: {
        project_name: "Nazwa projektu",
        order_number: "Nr zamówienia",
        realization_time: "Przewidywany termin realizacji",
        estimated_architect_commission: "Szacowana prowizja architekta",
        total_value: "Łączna wartość",
        status: "Status",
        no_orders: "Brak zamówień",
      },
      fulfillmentStatus: {
        fulfilled: "zrealizowane",
        unfulfilled: "niezrealizowane",
        partially_fulfilled: "częściowo zrealizowane",
        awaiting_shipment: "oczekuje na wysyłkę",
        scheduled: "zaplanowane",
        on_hold: "w oczekiwaniu",
      },
      details: {
        back: "Wstecz",
        order_details: "Szczegóły zamówienia",
        order: "Zamówienie",
        price: "Cena",
        amount: "Ilość",
        price_with_delivery: "Razem z dostawą",
      },
    },
  },
  /** Shopping list */
  list: {
    summary: "Razem",
    provision: "Prowizja",
    description: "Opis",
    currency: "Waluta",
    list_edit: "Edytuj listę",
    list_delete: "Usuń listę",
    list_delete_question: "Czy na pewno chcesz usunąć listę zakupową?",
    list_delete_long: "Usuń listę zakupową",
    admins_list: "Lista admina",
    architects_list: "Lista architekta",
    clients_list: "Lista inwestora",
    room_edit: "Edytuj pomieszczenie",
    room_delete: "Usuń pomieszczenie",
    room_delete_question: "Czy na pewno chcesz usunąć pomieszczenie?",
    file_noname: "Plik bez nazwy",
    file_delete: "Usuń plik",
    file_add: "Dodaj plik",
    vendor: "Producent",
    favourite_add: "Dodaj do ulubionych",
    favourite_remove: "Usuń z ulubionych",
    accepted: "Zaakceptowane przez klienta",
    not_accepted: "Niezaakceptowane przez klienta",
    amount: "Ilość",
    price_unit: "Cena jedn.",
    sum: "Suma",
    product_open_menu: "Otwórz menu produktu",
    product_edit: "Edytuj produkt",
    product_copy: "Kopiuj produkt",
    product_delete: "Usuń produkt",
    product_name: "Nazwa produktu",
    product_save: "Zapisz produkt",
    product_add: "Dodaj produkt",
    product_image: "Zdjęcie produktu",
    product_delete_question: "Czy na pewno chcesz usunąć produkt z listy?",
    comments: "Komentarze",
    comments_write: "Napisz komentarz",
    comments_open: "Otwórz komentarze",
    images_add: "Dodaj zdjęcia",
    image_add: "Dodaj zdjęcie",
    image_delete: "Usuń zdjęcie",
    product_link_add: "Dodaj link produktu",
    add: "Dodaj",
    save_changes: "Zapisz zmiany",

    category_add: "Dodaj kategorię",
    status_ordered: "Zamówione",
    status_not_ordered: "Niezamówione",
    fail_change_category_order: "Błąd zmiany kolejności kategorii",
  },
};
